import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { PersonneState } from '../../personne.state';

@Component({
  selector: 'app-sidenav-results',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SidenavComponent {
  @ViewChild(MatSidenav)
  sidenav: MatSidenav;

  @ViewChild(MatSidenavContent)
  content: MatSidenavContent;

  close() {
    this.sidenav.close();
  }

  open() {
    this.content.scrollTo({ top: 0 });
    this.sidenav.open();
  }

  toggleBodyScroll(isSidenavOpen: boolean) {
    if (isSidenavOpen && !PersonneState.IS_IOS()) {
      disableBodyScroll(this.content.getElementRef(), { reserveScrollBarGap: true });
    } else {
      enableBodyScroll(this.content.getElementRef());
    }
  }
}
